"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var swr_hooks_1 = require("@l2p/swr-hooks");
var SendPhoneCode = function (_a) {
    var _b, _c;
    var _d = _a.closeEdited, closeEdited = _d === void 0 ? function () { } : _d, phone = _a.phone, setPhone = _a.setPhone, setTmpResetToken = _a.setTmpResetToken;
    var t = (0, next_intl_1.useTranslations)('translation');
    var tReset = (0, next_intl_1.useTranslations)('resetPassword');
    var countries = (0, swr_hooks_1.useCountriesOptions)();
    var geoData = (0, swr_hooks_1.useGeo)().data;
    var _e = (0, swr_hooks_1.useForgotPassword)({
        successAction: function (data) {
            var _a;
            setTmpResetToken((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.tempToken);
            closeEdited();
        },
        errorAction: closeEdited,
    }), forgotPassword = _e.forgotPassword, isSubmitting = _e.isSubmitting;
    var country = (0, react_1.useMemo)(function () {
        var _a;
        return (_a = countries.find(function (item) { var _a; return item.value === ((_a = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _a === void 0 ? void 0 : _a.countryCode); })) === null || _a === void 0 ? void 0 : _a.value;
    }, [countries, (_b = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _b === void 0 ? void 0 : _b.countryCode]);
    var sendResetCode = function () {
        if (phone)
            forgotPassword({ login: "+".concat(phone) });
    };
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement(ui_components_1.ModalTitle, null,
            react_1.default.createElement("span", { dangerouslySetInnerHTML: {
                    __html: tReset('resetYourPassword'),
                } })),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.description }, tReset('enterYourPhoneAndSendCodeToResetPassword')),
        react_1.default.createElement(ui_components_1.PhoneInput, { name: "phone", value: phone, onChange: function (newPhone) {
                setPhone(newPhone);
            }, countryCodeEditable: true, country: !phone ? (_c = String(country || '')) === null || _c === void 0 ? void 0 : _c.toLowerCase() : undefined, placeholder: t('phone'), labelText: t('phone'), tooltip: react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                    __html: t.raw('lockPersonalData'),
                } }) }),
        react_1.default.createElement(ui_components_1.FixedButton, { height: "40px", width: "100%", type: "button", text: "upper", color: "gradient", maxWidth: "none", loading: isSubmitting, disabled: !Boolean(phone) || !Boolean((phone === null || phone === void 0 ? void 0 : phone.length) && (phone === null || phone === void 0 ? void 0 : phone.length) >= 8), onClick: sendResetCode }, t('confirm'))));
};
exports.default = SendPhoneCode;
